

//Official
export const rootUrl = 'https://api.blazebots.com.br/';
export const apiUrl = 'https://api.blazebots.com.br/';

// export const rootUrl = 'http://localhost:3010/';
// export const apiUrl = 'http://localhost:3010/';
export const SCROLL =200;